<template>
  <TableLayout :permissions="['business:article:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >

      <el-form-item label="文章名称" prop="title">
        <el-input v-model="searchForm.title" placeholder="请输入文章名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="所属分类" prop="labelId">
        <el-select
          v-model="searchForm.labelId"
          placeholder="请选择分类"
        >
          <el-option v-for="item in labels" :key="item.id" :value="item.id" :label="item.name" />
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:article:create', 'business:article:delete']">
        <li><el-button type="primary" @click="$refs.operaArticleWindow.open('新建咖啡百科文章信')" icon="el-icon-plus" v-permissions="['business:article:create']">新建</el-button></li>
        <li><el-button  type="danger" @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:article:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="title" label="标题" min-width="100px"></el-table-column>
        <el-table-column prop="imgurlfull" label="背景图主图" align="center" min-width="100px">
          <template slot-scope="{row}">
            <!-- <el-image :scr="row.imgFullurl" :preview-src-list="[row.imgFullurl]"></el-image> -->
            <!-- {{ row.imgFullUrl }} -->
            <el-image
              :lazy="true"
              style="with:50px;height:50px;"
              :scr="row.imgFullUrl"
              :preview-src-list="[row.imgFullUrl]"
            ></el-image>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="labelName" label="所属分类" min-width="100px"></el-table-column> -->
        <el-table-column prop="lableName" label="所属分类" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码" align="center" min-width="100px">
          <template slot-scope="{row}">{{ row.sortnum || '0' }}</template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" align="center" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:article:update', 'business:article:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
          align="center"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaArticleWindow.open('编辑咖啡百科文章', row)" icon="el-icon-edit" v-permissions="['business:article:update']">编辑</el-button>
            <el-button type="text" style="color: red;"  @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:article:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaArticleWindow ref="operaArticleWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaArticleWindow from '@/components/business/OperaArticleWindow'
import { fetchList as labelList } from '@/api/business/labels'
export default {
  name: 'Article',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaArticleWindow },
  data () {
    return {
      labels: [],
      uploadData: {
        folder: 'activity'
      },
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        info: '',
        title: '',
        sortnum: '',
        status: '',
        imgurl: '',
        labelId: '',
        content: ''
      }
    }
  },
  provide() {
    return {
      labels: () => this.labels
    }
  },
  created () {
    this.config({
      module: '咖啡百科文章信息表',
      api: '/business/article',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  mounted() {
    labelList({
      capacity: 999,
      model: {
        type: 8
      }
    })
      .then(res => {
        this.labels = res.records
      })
  }
}
</script>
